export default __webpack_public_path__ + "static/media/DIAGNOSTIC_RGB.1baf1281.jpg";